import { IFormSelectItem } from '../types/form-select-item.type';

export const translateSelectList = (items: IFormSelectItem[], t: Function): IFormSelectItem[] =>
  items.map(({ code, name }) => ({ code, name: t(name) }));
